exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-listing {\n  margin-top: 15px;\n}\n.sparql-listing-entries {\n  -webkit-padding-start: 0px;\n}\n.sparql-listing-entry:hover {\n  background-color: #f1f1f1;\n}\n.sparql-listing-group .badge {\n  color: black;\n  background-color: white;\n}\n.sparql-listing-entries .badge {\n  color: white;\n  background-color: #868e96;\n}\n.sparql-listing .text-item-icon {\n  margin-right: 4px;\n}\n.sparql-listing .text-item-icon.flag-icon {\n  margin-right: 8px;\n}\n", ""]);

// exports
